import { Account } from "views/account";
import { Commissions } from "views/account/commissions";
import { Company } from "views/account/company/company";
import { Password } from "views/account/password";
import { Profile } from "views/account/profile";
import { Signature } from "views/account/signature/signature";
import { Users } from "views/account/users";

const Routes = [
  {
    path: "/app/account",
    view: Account,
    layout: "app",
    permission: "user",
    title: "Your Account",
  },
  {
    path: "/app/account/profile",
    view: Profile,
    layout: "app",
    permission: "user",
    title: "Your Profile",
  },
  {
    path: "/app/account/signature",
    view: Signature,
    layout: "app",
    permission: "user",
    title: "Your Signature",
  },
  {
    path: "/app/account/password",
    view: Password,
    layout: "app",
    permission: "user",
    title: "Change Password",
  },
  {
    path: "/app/account/company",
    view: Company,
    layout: "app",
    permission: "owner",
    title: "Company",
  },
  {
    path: "/app/account/commissions",
    view: Commissions,
    layout: "app",
    permission: "owner",
    title: "Commissions",
  },
  {
    path: "/app/account/users",
    view: Users,
    layout: "app",
    permission: "owner",
    title: "Users",
  },
];

export default Routes;
